import { FrontendPlugin } from '@backstage/frontend-plugin-api';
import { convertLegacyPlugin } from '@backstage/core-compat-api';
import {
  convertLegacyEntityCardExtension,
  convertLegacyEntityContentExtension,
} from '@backstage/plugin-catalog-react/alpha';
import {
  argocdPlugin,
  ArgocdDeploymentSummary,
  ArgocdDeploymentLifecycle,
  isArgocdConfigured,
} from '@backstage-community/plugin-argocd';
import { Entity } from '@backstage/catalog-model';

const isArgoCDService = (entity: Entity): boolean =>
  entity.kind === 'Component' &&
  (entity as any).spec?.type === 'service' &&
  isArgocdConfigured(entity);

export const argoCDCompatPlugin: FrontendPlugin = convertLegacyPlugin(
  argocdPlugin,
  {
    extensions: [
      convertLegacyEntityCardExtension(ArgocdDeploymentSummary, {
        name: 'argocd-deployment-summary',
        filter: isArgoCDService,
      }),
      convertLegacyEntityContentExtension(ArgocdDeploymentLifecycle, {
        name: 'argocd-deployment-lifecycle',
        path: '/argocd',
        title: 'ArgoCD',
        filter: isArgoCDService,
      }),
    ],
  },
);
